function resizedw(){
    // $('section.blog-list-item .info').matchHeight();
}
var doit;
window.onresize = function(){
  clearTimeout(doit);
  doit = setTimeout(resizedw, 100);
};

	// $('section.blog-list-item .info').matchHeight();
